import React from "react";
import { useSelector } from "react-redux";

import Layout from "../../../components/UI/Layout/Layout";
import BankReconciliationList from "./BankReconciliationList";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";

export var ScreensBankReconciliation = function() {
    var bankReconciliation = useSelector(function(state) {
        return state.bankReconciliation;
    });
    var isLoading = bankReconciliation && bankReconciliation.isLoading;

    return (
        <div>
            <LoadingTopBar isActive={isLoading} />
            <Layout>
                <BankReconciliationList />
            </Layout>
        </div>
    );
};
